import src from "IMAGE";
export default { src, width: 321, height: 169, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAQ0lEQVR42m3KsQkAIRQE0V/BHdxZhQYGgphoamgLYmT/FTiCIIgLL5oV2XuRlkcu+xHg8Z1RwSEjwpwni46Gggo9wwDA5wQHtkuPRQAAAABJRU5ErkJggg=="};
